<div
  class="  filter-container mb-4 flex flex-col gap-2 rounded-lg border p-6 filters-shadow"
  (click)="onContainerClick($event)">
  <div class="grid grid-cols-3 gap-6 py-2 pt-4">
    <div>
      <app-filter-input
        [label]="isArabic() ? 'عنوان العربة' : 'Cart Title'"
        [placeholder]="isArabic() ? 'ابحث بعنوان العربة...' : 'Search by cart title...'"
        type="text"
        [(value)]="cartTitleSearch" />
    </div>

    <div>
      <app-filter-product-search
        [label]="isArabic() ? 'الصيدلية' : 'Pharmacy'"
        [placeholder]="isArabic() ? 'ابحث بالصيدلية...' : 'Search by pharmacy...'"
        [loading]="pharmacyLoading()"
        [error]="pharmacyError()"
        [results]="pharmacyResults()"
        [(searchTerm)]="pharmacySearchTerm"
        [(showDropdown)]="showPharmacyDropdown"
        (searchChange)="onPharmacySearchChange($event)"
        (selectItem)="onPharmacySelect($event)" />
    </div>

    <div>
      <app-filter-product-search
        [label]="isArabic() ? 'مالك الصيدلية' : 'Pharmacy Owner'"
        [placeholder]="isArabic() ? 'ابحث باسم المالك...' : 'Search by owner name...'"
        [loading]="ownerLoading()"
        [error]="ownerError()"
        [results]="ownerResults()"
        [(searchTerm)]="ownerSearchTerm"
        [(showDropdown)]="showOwnerDropdown"
        (searchChange)="onOwnerSearchChange($event)"
        (selectItem)="onOwnerSelect($event)" />
    </div>

    <div *hasScope="SCOPES.PHARMACIES.ASSIGN_TELESALES">
      <app-filter-product-search
        [label]="isArabic() ? 'مُعيّن إلى' : 'Assigned To'"
        [placeholder]="isArabic() ? 'ابحث باسم موظف المبيعات...' : 'Search tele-sales representative...'"
        [loading]="assignedLoading()"
        [error]="assignedError()"
        [results]="assignedResults()"
        [(searchTerm)]="assignedSearchTerm"
        [(showDropdown)]="showAssignedDropdown"
        (searchChange)="onAssignedSearchChange($event)"
        (selectItem)="onAssignedSelect($event)" />

      @if (selectedAssignedIds().length > 0) {
        <div class="mt-2 flex flex-wrap gap-2">
          @for (tag of selectedAssignedIds(); track tag.id) {
            <span
              class="borderTabsColor/30 bgTabsColor/10 textTabsColor flex items-center gap-1 rounded-full border px-3 py-0.5 text-[12px] font-medium">
              {{ tag.fullName }}
              <button
                type="button"
                (click)="removeAssignedTag(tag.id)"
                class="hover:bgTabsColor/20 ml-1 flex h-4 w-4 cursor-pointer items-center justify-center rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="3">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </span>
          }
        </div>
      }
    </div>

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء من' : 'Created On From'"
      [value]="createdOnFrom()"
      (valueChange)="createdOnFrom.set($event)"
      [isInvalid]="createdDateInvalid()" />

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء إلى' : 'Created On To'"
      [value]="createdOnTo()"
      (valueChange)="createdOnTo.set($event)"
      [isInvalid]="createdDateInvalid()" />

    <!-- @if (createdDateInvalid()) {
      <div class="flex items-center">
        <p class="text-[12px] text-red-500">
          {{ isArabic() ? "تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية" : "From date cannot be after To date" }}
        </p>
      </div>
    } @else {
      <div></div>
    } -->

    <div></div>

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ آخر تعديل من' : 'Last Modified On From'"
      [value]="lastModifiedOnFrom()"
      (valueChange)="lastModifiedOnFrom.set($event)"
      [isInvalid]="lastModifiedDateInvalid()" />

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ آخر تعديل إلى' : 'Last Modified On To'"
      [value]="lastModifiedOnTo()"
      (valueChange)="lastModifiedOnTo.set($event)"
      [isInvalid]="lastModifiedDateInvalid()" />

    @if (lastModifiedDateInvalid()) {
      <div class="flex items-center">
        <p class="text-[12px] text-red-500">
          {{ isArabic() ? "تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية" : "From date cannot be after To date" }}
        </p>
      </div>
    } @else {
      <div></div>
    }
  </div>
  <div class=" filter-footer mt-4 flex justify-between border-t pt-4 pb-4">
    <app-filter-sorting-component
      [orderBy]="filters().orderBy!"
      (orderByChange)="filters().orderBy = $event"
      [orderDir]="filters().orderDir!"
      [sortOptions]="sortOptions()"
      (toggleOrder)="onToggleSortOrder()" />

    <div class="flex items-end justify-end gap-3">

         <app-submit-button type="secondary" (click)="onResetFilters()">
          <span i18n="@@adminProductsResetButton">Clear</span>
        </app-submit-button>

        <app-submit-button type="primary" (click)="onApplyFilters()">
          <span i18n="@@adminProductsApplyButton">Apply</span>
        </app-submit-button>
    </div>
  </div>
</div>
